import Link from "next/link";

export const LinkButton = ({
  title,
  slug,
  classes = "text-blue-700",
}: {
  title: string;
  slug: string;
  classes?: string;
}) => {
  return (
    <Link
      href={slug}
      className={`font-bold rounded inline-block px-5 py-2 border border-blue-700 hover:bg-blue-700 hover:text-white duration-300 ${classes}`}
    >
      {title}
    </Link>
  );
};
